export const NO_TRANSITIONS = {
  enterRight: '',
  enterLeft: '',
  exitRight: '',
  exitLeft: ''
};